import React, { CSSProperties } from 'react';
import { PossiblyResponsiveValue, useResponsiveValue } from '../../hooks/useResponsiveValue';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { cssVariables, styles } from './Base.css';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type LoadingSkeletonProps = {
  width?: PossiblyResponsiveValue<React.CSSProperties['width']>;
  height?: PossiblyResponsiveValue<React.CSSProperties['height']>;
  backgroundColor?: PossiblyResponsiveValue<React.CSSProperties['backgroundColor']>;
  shimmerColor?: PossiblyResponsiveValue<React.CSSProperties['backgroundColor']>;
  border?: PossiblyResponsiveValue<React.CSSProperties['border']>;
  shouldShimmer?: PossiblyResponsiveValue<boolean>;
  className?: string;
};

export const Base = ({
  width: widthProp = '100%',
  height: heightProp = { xs: '200px', md: '150px' },
  backgroundColor: backgroundColorProp = 'transparent',
  shimmerColor: shimmerColorProp = '#F9F9F9',
  border: borderProp = `1px solid ${palette.border.main}`,
  className,
  style,
  children,
}: Omit<LoadingSkeletonProps, 'shouldShimmer'> & {
  children: React.ReactNode;
  style?: CSSProperties;
}) => {
  const width = useResponsiveValue(widthProp);
  const height = useResponsiveValue(heightProp);
  const backgroundColor = useResponsiveValue(backgroundColorProp);
  const shimmerColor = useResponsiveValue(shimmerColorProp);
  const border = useResponsiveValue(borderProp);

  return (
    <div
      className={classNames([styles.container, className])}
      style={{
        ...style,
        ...assignInlineVars({
          [cssVariables.backgroundColor]: backgroundColor,
          [cssVariables.shimmerColor]: shimmerColor,
          [cssVariables.border]: `${border}`,
          [cssVariables.width]: `${width}`,
          [cssVariables.height]: `${height}`,
        }),
      }}
    >
      {children}
    </div>
  );
};
